import { IMatch } from '../pages/tourDetails/TournamentPlay/components/PlayTag/PlayTag';

function courtFromMatch(match: Record<string, unknown>): number | null {
  const court = match.court;
  if (court == null) {
    return null;
  }
  if (typeof court === 'number') {
    return court;
  }
  if (typeof court === 'object' && court !== null && 'id' in court) {
    const id = (court as { id: unknown }).id;
    return typeof id === 'number' ? id : null;
  }
  return null;
}

export function isGoldToFormString(isGold: unknown): string {
  if (isGold === undefined || isGold === null) return 'false';
  if (typeof isGold === 'string') return isGold;
  if (typeof isGold === 'boolean') return String(isGold);
  return Boolean(isGold).toString();
}

export function normalizePlayMatchFromApi(match: object): IMatch {
  const row = match as Record<string, unknown>;
  return {
    ...match,
    isGold: isGoldToFormString(row.isGold),
    court: courtFromMatch(row),
  } as IMatch;
}

export function normalizePlayMatchesFromApi(matches: readonly object[]): IMatch[] {
  return matches.map(normalizePlayMatchFromApi);
}
